import TitileAndArrowBack from "../../components/TitileAndArrowBack/TitileAndArrowBack";
import React, { useState, useEffect, useRef } from "react";
import withAuth from "../../hoc/withAuth";
function ProgramSettings(props) {
  const [isShowCityMenu, setisShowCityMenu] = useState(false);
  const allLanguage = [];
  const Language = [
    { id: 1, name: "فارسی" },
    { id: 2, name: "انگلیسی" },
    { id: 3, name: "آلمانی" },
    { id: 4, name: "ترکی" },
  ];
  const getCityHandler = (item) => {
    const checkDuplicate = allLanguage.includes(item);
    if (!checkDuplicate) {
      allLanguage.push(item);
    }
  };

  const [isChecked1, setIsChecked1] = useState(false); // Dark Mode
  const [isChecked2, setIsChecked2] = useState(false);
  const [isChecked3, setIsChecked3] = useState(false);

  // Dark Mode
  const handleToggle1 = () => {
    setIsChecked1(!isChecked1);
    if (isChecked1) {
      document.getElementById("root").classList.remove("dark-mode");
      localStorage.setItem("veeu-dark-mode", false);
    } else {
      document.getElementById("root").classList.add("dark-mode");
      localStorage.setItem("veeu-dark-mode", true);
    }
  };
  const handleToggle2 = () => {
    setIsChecked2(!isChecked2);
  };
  const handleToggle3 = () => {
    setIsChecked3(!isChecked3);
  };
  // modal
  const [openSuccess, setOpenSuccess] = useState(false);
  const handleOpenSuccess = () => {
    setOpenSuccess(true);
    document.querySelector(".bg").style.pointerEvents = "none";
    document.querySelector(".bg").style.filter = "blur(0.1rem)";
  };
  const handleclose = () => {
    setOpenSuccess(false);
    document.querySelector(".bg").style.pointerEvents = "auto";
    document.querySelector(".bg").style.filter = "none";
  };
  // handle click outside for hide modals
  useEffect(() => {
    let darkMode = localStorage.getItem("veeu-dark-mode"); // Get current state

    if (darkMode === "true") {
      setIsChecked1(true);
    }

    const handleClickOutside = (event) => {
      const bgElement = document.querySelector(".bg");
      const modalElement = document.querySelector(".modal");
      if (
        bgElement &&
        !bgElement.contains(event.target) &&
        !event.target.closest(".modal")
      ) {
        bgElement.style.pointerEvents = "auto";
        bgElement.style.filter = "none";
        setOpenSuccess(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  // modal Success
  const [openSuccessFinal, setOpenSuccessFinal] = useState(false);
  const handleOpenSuccessFinal = () => {
    setOpenSuccessFinal(true);
    setOpenSuccess(false);
    setTimeout(() => {
      setOpenSuccessFinal(false);
      document.querySelector(".bg").style.pointerEvents = "auto";
      document.querySelector(".bg").style.filter = "blur(0rem)";
    }, 1000);
    document.querySelector(".bg").style.pointerEvents = "none";
    document.querySelector(".bg").style.filter = "blur(0.1rem)";
  };

  return (
    <>
      <TitileAndArrowBack title="تنظیمات برنامه" />
      <div className="flex flex-col px-3 bg my-2 h-full w-full bg">
        <div className="border border-[1px] border-t-0 border-r-0 border-l-0 w-full py-3">
          <p>تنظیمات ظاهر برنامه</p>
          <div className="flex items-center cursor-pointer my-2">
            <p className="text-sm ml-3 text-gray-700 font-medium">تیره</p>
            <label
              htmlFor="toggle"
              className="flex items-center cursor-pointer my-2"
            >
              <div className="relative">
                <input
                  id="toggle"
                  type="checkbox"
                  className="hidden"
                  checked={isChecked1}
                  onChange={handleToggle1}
                />
                <div
                  className={`border border-gray-500 border-[1px] toggle-line w-[80px] h-6 rounded-full shadow-inner ${isChecked1 ? " bg-green-800" : ""
                    } transition`}
                ></div>
                <div
                  className={`absolute bg-green-500 top-1 left-[2px] mx-1 toggle-dot absolute w-4 h-4  rounded-full shadow ${isChecked1 ? "translate-x-full bg-white right-5" : "-left-1"
                    } transition`}
                ></div>
              </div>
            </label>
            <p className="text-sm mr-3 text-gray-700 font-medium">روشن</p>
          </div>
        </div>
        <div>
          {/* select */}
          <div className="border border-[1px] border-t-0 border-r-0 border-l-0 w-full py-3">
            <div className="mt-3 flex items-center justify-start w-full">
              <div className="flex w-1/2">
                <div className="relative w-full h-auto">
                  <div
                    className="border-b border-b-gray-800 p-2 flex items-center justify-between w-full"
                    onClick={() => setisShowCityMenu(!isShowCityMenu)}
                  >
                    <span>انتخاب زبان</span>
                    <img
                      className={`transition-all ${isShowCityMenu ? "rotate-0" : "rotate-180"
                        }`}
                      src="/icons/arrow-bottom.svg"
                      alt="arrow"
                    />
                  </div>
                  <ul
                    className={`shadow-[0px_0px_5px_0px_#4a5568] w-full absolute bg-white z-40 top-12 transition ease-in-out delay-150 ${isShowCityMenu ? "h-max" : "h-[0px] "
                      } overflow-hidden rounded-xl`}
                  >
                    {Language.map((item, index) => (
                      <li
                        onClick={() => getCityHandler(item)}
                        key={item.id}
                        className="flex items-center gap-2 mt-2"
                      >
                        <input
                          id={item.id}
                          type="checkbox"
                          name={item.name}
                          value={item.name}
                          disabled={item.name !== "فارسی"}
                          checked={item.name === "فارسی"}
                        />
                        <label htmlFor={item.id}>{item.name}</label>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* delet history */}
          <div className="border border-[1px] border-t-0 border-r-0 border-l-0 w-full py-3">
            <button className="p-2 bg-gray-200 rounded rounded-lg">
              پاک کردن تاریخچه جست‌وجو
            </button>
          </div>
          {/* Notice and warning*/}
          <div className="border border-[1px] border-t-0 border-r-0 border-l-0 w-full py-3  overflow-hidden">
            <p>اعلان و هشدار</p>
            {/* toggle1 */}
            <div className="flex items-center justify-between cursor-pointer my-2  overflow-hidden">
              <p className="text-sm ml-3 text-gray-700 font-medium">
                بی صدا کردن اعلان ها
              </p>
              <label
                htmlFor="toggle2"
                className="flex items-center justify-between cursor-pointer my-2  overflow-hidden"
              >
                <div className="relative  overflow-hidden">
                  <input
                    id="toggle2"
                    type="checkbox"
                    className="hidden"
                    // checked={isChecked2 ?? ""}
                    onChange={handleToggle2}
                  />
                  <div
                    className={`border border-gray-500 border-[1px] toggle-line w-[150px] h-8 rounded-xl shadow-inner  overflow-hidden ${isChecked2 ? " " : ""
                      } transition`}
                  ></div>
                  <div className="">
                    <div className="absolute px-2 bottom-1 flex w-full justify-between overflow-hidden">
                      <p
                        className={`z-20 ${isChecked2 ? "text-gray-900" : "text-white"
                          } transition`}
                      >
                        فعال
                      </p>
                      <p
                        className={`z-20 ${isChecked2 ? "text-white" : "text-gray-900"
                          } transition`}
                      >
                        غیر فعال
                      </p>
                      <div
                        className={`absolute top-0 left-0 z-10 bg-green-500 bottom-0  mx-1 toggle-dot w-[70px] h-6 shadow  overflow-hidden ${isChecked2
                            ? "rounded-l-lg translate-x-full bg-red-600 right-[140px]"
                            : "rounded-r-lg right-[2px]"
                          } transition`}
                      ></div>
                    </div>
                  </div>
                </div>
              </label>
            </div>

            {/* toggle2 */}
            <div className="flex items-center justify-between cursor-pointer my-2  overflow-hidden">
              <p className="text-sm ml-3 text-gray-700 font-medium">
                نمایش پیام ها در نوار اعلان
              </p>
              <label
                htmlFor="toggle3"
                className="flex items-center justify-between cursor-pointer my-2  overflow-hidden"
              >
                <div className="relative  overflow-hidden">
                  <input
                    id="toggle3"
                    type="checkbox"
                    className="hidden"
                    // checked={isChecked3 ?? ""}
                    onChange={handleToggle3}
                  />
                  <div
                    className={`border border-gray-500 border-[1px] toggle-line w-[150px] h-8 rounded-xl shadow-inner  overflow-hidden ${isChecked3 ? " " : ""
                      } transition`}
                  ></div>
                  <div className="relative">
                    <div className="absolute px-2 bottom-1 flex w-full justify-between  overflow-hidden">
                      <p
                        className={`z-20 ${isChecked3 ? "text-gray-900" : "text-white"
                          } transition`}
                      >
                        فعال
                      </p>
                      <p
                        className={`z-20 ${isChecked3 ? "text-white" : "text-gray-900"
                          } transition`}
                      >
                        غیر فعال
                      </p>
                      <div
                        className={`absolute z-10 bg-green-500 bottom-0 mx-1 toggle-dot w-[70px] h-6 shadow   overflow-hidden ${isChecked3
                            ? "rounded-l-lg translate-x-full bg-red-600 right-[140px]"
                            : "rounded-r-lg right-[2px]"
                          } transition`}
                      ></div>
                    </div>
                  </div>
                </div>
              </label>
            </div>

            <label
              htmlFor="toggle"
              className="flex items-center cursor-pointer my-2"
            >
              <div className="relative">
                <input
                  id="toggle"
                  type="checkbox"
                  className="hidden"
                  // checked={setIsChecked1}
                  onChange={handleToggle1}
                />
                {/* <div className={`flex justify-between border border-gray-500 border-[1px] toggle-line w-[200px] h-6 rounded-full shadow-inner ${
                                        isChecked1 ? ' ' : ''
                                    } transition`}>
                                        <p className={`z-20 ${
                                            isChecked1 ? 'text-gray-900' : 'text-white'
                                        } transition`}>فعال</p>
                                        <p className={`z-20 ${
                                            isChecked1 ? 'text-white' : 'text-gray-900'
                                        } transition`}>غیر فعال</p>
                                        <div
                                    className={`absolute bg-green-500 top-1  mx-1 toggle-dot absolute w-4 h-4  rounded-full shadow ${
                                        isChecked1 ? 'absolute translate-x-full bg-red-500 top-1 left-0' : ''
                                    } transition`}
                                ></div>
                                </div> */}
              </div>
            </label>
          </div>
        </div>
        <div className=" w-full flex items-center justify-center mt-20">
          <button
            onClick={() => {
              // props.setIsShowAppSettingModal(false)
              setOpenSuccessFinal(true);
              if (props.setIsShowAppSettingModal) {
                props.setIsShowAppSettingModal(false)
              }
              setTimeout(() => {
                setOpenSuccessFinal(false);
              }, 2000);
            }}
            className="p-1 bg-green-700 rounded rounded-lg text-white px-8"
          >
            اعمال تغییرات
          </button>
        </div>
      </div>
      {/* edit modal */}
      {/* {openSuccess && (
             <div className={`fade-in modal z-50 fixed top-0 w-full h-screen flex items-center justify-center`}>
                <div className='rounded-xl p-4 bg-red-400 text-white flex flex-col items-center justify-center gap-4 w-[80%] shadow-sm relative'>
                    <p className='text-xl font-bold'>آیا از حذف اطمینان دارید؟</p>
                    <div className='flex justify-around items-center w-full'>
                        <button onClick={handleOpenSuccessFinal} className='mx-3 w-1/2 text-white-900 px-6 py-2 rounded-xl bg-red-500' >بله</button>
                        <button onClick={handleclose} className='mx-3 w-1/2 text-red-800 px-6 py-2 rounded-xl bg-orange-500 ' >خیر</button>
                    </div>
                </div>
            </div>
            )} */}
      {/* modal Success */}
      {openSuccessFinal && (
        <div
          className={`fade-in z-50 fixed bottom-0 w-full h-full flex items-center justify-center bg-[#8d8d8da1] backdrop-blur-sm`}
        >
          <div className="rounded-xl p-4 successAlert text-white flex flex-col items-center justify-center gap-4 w-[80%] shadow-sm relative bg-modal-blue text-white">
            <p className="text-xl font-bold">با موفقیت انجام شد</p>
          </div>
        </div>
      )}
    </>
  );
}

export default withAuth(ProgramSettings);
